import { useEffect } from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import Config from '@/config'
import userStatus from '@/constants/userStatus.constants'
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'
import { useCustomHistory } from '@/hooks'
import { getURL } from '@/utils'

const DataLayerWrapper = () => {
	const userAccount = useSelector(state => state.auth.account, shallowEqual)
	const uiNav = useSelector(state => state.ui.navigation, shallowEqual)
	const sendDataToGTM = useGTMDispatch()
	const history = useCustomHistory()

	const device = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Windows Phone/i.test(
		navigator.userAgent
	)
		? 'Mobile'
		: 'Desktop'

	useEffect(() => {

		const vibiaWebPath = Config.getInstance().getConfig('endpoints.vibia-public.url')
		const vibiaWebUrl = getURL(vibiaWebPath, 'app')

		sendDataToGTM({
			dl_catalogo: (uiNav.catalog === 'int' || uiNav.catalog === 16) ? 'internacional' : 'usa',
			dl_clientcode: userAccount?.id || '',
			dl_device: device,
			dl_language: uiNav.language,
			dl_page_name: location.pathname,
			dl_page_type: location.pathname.includes('order') ? 'My Orders' : 'My Project',
			dl_host_name: vibiaWebUrl,
			dl_application: 'e-project',
			dl_user_id: userAccount?.id || '',
			dl_user_role: (userAccount?.roles && userAccount.roles[0]) || '',
			dl_profile_type: userAccount?.profesion || '',
			dl_login_option: userAccount?.registerType || '',
			dl_market_sector: userAccount?.company?.companyType?.description || '',
			dl_user_status: Object.keys(userStatus).find((key) => userStatus[key] === userAccount?.status) || '',
			dl_user_type: userAccount?.userType,
			dl_session_type: userAccount ? 'logged' : 'not logged',
		})
	}, [userAccount])

	useEffect(() =>
		history.listen(
			(location) => {
				sendDataToGTM({
					event: 'virtual_page',
					dl_page_name: location.pathname,
					dl_page_type: location.pathname.includes('order') ? 'My Orders' : 'My Project'
				})
			},
			[location.pathname]
		)
	)

	return null
}

export default DataLayerWrapper
